export default __webpack_public_path__ + "static/media/sidebar-1.258c9cbb.jpg";